import React from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { msalInstance } from "./msalInstance";

function TestLogin() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  return (
    <div style={{ padding: 32 }}>
      <h2>MSAL Minimal Test</h2>
      <div>Is authenticated: <b>{isAuthenticated ? "Yes" : "No"}</b></div>
      <div>Accounts: <pre>{JSON.stringify(accounts, null, 2)}</pre></div>
      <button onClick={() => instance.loginRedirect()}>Login</button>
    </div>
  );
}

export default function MsalTestApp() {
  // Remove the extra MsalProvider here. The app is already wrapped at the top level.
  return <TestLogin />;
}
